// import React from 'react'

// export const BlockedList = () => {
//   return (
//     <div>BlockedList</div>
//   )
// }
import React, { useEffect, useState } from "react";
import { dashboardIcon } from "../../assets/img";
import DateRange from "../DateRange/DateRange";
import DateRange1 from "../DateRange/DateRange1";
import Select from "react-select";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { useLocation } from "react-router-dom";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";

function BlockedList() {
  const [isData, setIsData] = useState({});
  const { paginationData } = useGlobalContext();
  const { pathname } = useLocation();
  const path = pathname?.replace("/", "");

  const [selectedFilter, setSelectedFilter] = useState(
    paginationData?.[path]
      ? { ...paginationData?.[path] }
      : {
          from: "",
          to: "",
        }
  );

  const getTopCard = async () => {
    let url = URLS.DASHBOARBLOCKED_CARD;
    const params = [];

    if (selectedFilter.from && selectedFilter.to) {
      params.push(`from_date=${selectedFilter.from}`);
      params.push(`to_date=${selectedFilter.to}`);
    }

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    try {
      let res = await get(url);
      if (res?.status === "success") {
        setIsData(res?.data ?? {});
      }
    } catch (error) {
      console.error("Error fetching revenue data:", error);
    }
  };

  useEffect(() => {
    getTopCard();
  }, [selectedFilter.from, selectedFilter.to]);

  const handleChangeFilter = (name, val) => {
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  return (
    <>
      <div
        style={{
          padding: 20,
          width: "100%",
          background: "#FFFFFF",
          boxShadow: "0px 1px 10.4px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 10,
          }}
        >
          <p
            style={{
              fontStyle: "normal",
              fontWeight: "700",
              fontSize: "17px",
              lineHeight: "23px",
              display: "flex",
              alignItems: "center",
              color: "#222227",
            }}
          >
            BlockedList
          </p>

          <div className="d-flex ac-jb mt-3 gap-1 flex-wrap">
            <DateRange
              setFromDate={(date) => handleChangeFilter("from", date)}
              setToDate={(date) => handleChangeFilter("to", date)}
            />
          </div>
        </div>

        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {/* ---------- Smaller Card 1 ---------- */}
          <div
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "12px",
              padding: "8px 14px",
              marginTop: "15px",
              width: "45%",
              minHeight: "90px",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                }}
              >
                Property Block
              </p>
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#000000",
                  margin: 0,
                }}
              >
                {isData?.property_block &&
                  (isData?.property_block || 0).toFixed(2)}
              </p>
            </div>

            <div>
              <div style={{ width: "26px", height: "26px" }}>
                <img
                  src={dashboardIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>

          {/* ---------- Smaller Card 2 ---------- */}
          <div
            style={{
              border: "1px solid #EEEEEE",
              display: "flex",
              justifyContent: "space-between",
              borderRadius: "12px",
              padding: "8px 14px",
              marginTop: "15px",
              width: "45%",
              minHeight: "90px",
            }}
          >
            <div>
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#9ca3af",
                  margin: 0,
                }}
              >
                Room Block
              </p>
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#000000",
                  margin: 0,
                }}
              >
                {isData?.room_block && (isData?.room_block || 0).toFixed(2)}
              </p>
            </div>

            <div>
              <div style={{ width: "26px", height: "26px" }}>
                <img
                  src={dashboardIcon}
                  alt=""
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BlockedList;
